import React from 'react'
import PropTypes from 'prop-types'

import { openUrl } from '../../../utils/UrlUtils'

const ClickableTileWrapper = ({ url, target, className, children }) => {
  return (
    <div role="presentation" onClick={() => openUrl(url, target)} className={`tile-wrapper group ${className}`}>
      {children}
    </div>
  )
}

ClickableTileWrapper.propTypes = {
  url: PropTypes.string,
  target: PropTypes.oneOf(['_self', '_blank']),
  className: PropTypes.string,
  children: PropTypes.node,
}

ClickableTileWrapper.defaultProps = {
  className: '',
}

export default ClickableTileWrapper
